<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <v-tab
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta }"
        exact>
        {{ opcion.nombre }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'contratoEjecucionGenerales',
          icono: '',
        },
        {
          nombre: 'Frentes',
          ruta: 'contratoFrentes',
          icono: '',
        },
        {
          nombre: 'Actividades',
          ruta: 'contratoReporteActividades',
          icono: '',
        },
        {
          nombre: 'Avance Físico',
          ruta: 'contratosAvanceReal',
          icono: '',
        },
        {
          nombre: 'Ficha',
          ruta: 'contratoActiviodadesPrincipales',
          icono: '',
        },
        {
          nombre: 'Inventarios',
          ruta: 'contratoInventarios',
          icono: '',
        },
        /*
        {
          nombre: 'Anticipos',
          ruta: 'contratoEjecucionAnticipos',
          icono: '',
        }, */
        {
          nombre: 'Catálogo',
          ruta: 'contratoEjecucionCatalogo',
          icono: '',
        },
        {
          nombre: 'Programa',
          ruta: 'contratoEjecucionPrograma',
          icono: '',
        },
        {
          nombre: 'Estimaciones',
          ruta: 'contratoEjecucionEstimaciones',
          icono: '',
        },
        /*
        {
          nombre: 'Gráfica',
          ruta: 'contratoEjecucionGraficaAvanceFisico',
          icon: '',
        }, */
        /*
        {
          nombre: 'Gráfica',
          ruta: 'contratoGraficaComparativaAvances',
          icono: '',
        }, */
        {
          nombre: 'Pendientes',
          ruta: 'contratoEjecucionActividades',
          icono: '',
        },
        {
          nombre: 'Fechas',
          ruta: 'contratoFechas',
          icon: '',
        },
        {
          nombre: 'Album Fotográfico',
          ruta: 'contratoEjecucionAlbumFrentes',
          icono: '',
        },
        {
          nombre: 'Videos',
          ruta: 'contratoVideos',
          icon: '',
        },
        /*
        {
          nombre: 'Garantías',
          ruta: 'contratoGarantias',
          icon: '',
        }, */
        {
          nombre: 'Expediente',
          ruta: 'contratoEjecucionExpediente',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
